import React, { useState } from "react";
import { useDataContext } from "../context/datacontext";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import useLocation from "../hooks/useLocation";

const Config = () => {
  const { accessKey, setAccessKey } = useDataContext();
  const [teamAccessKey, setTeamAccessKey] = useState(accessKey);

  const { set } = useLocation();

  const handleSubmit = (event) => {
    setAccessKey(teamAccessKey);
    set("#home")
  };

  return (
    <div>
      <h1>Config</h1>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Form.Label>Access Key</Form.Label>
          <Form.Control type="text" placeholder="Enter access key" value={teamAccessKey} onChange={(ev)=>{setTeamAccessKey(ev.target.value)}}/>
          <Form.Text className="text-muted">
            Get your access key form [me] [account] from blackout rugby classic website.
          </Form.Text>
        </Form.Group>
        <Button variant="primary" type="submit">
        Submit
      </Button>
      </Form>
    </div>
  );
};

export default Config;
